<template>
<div class="benefits-card">
  <h4 class="title">{{ $props.title }}</h4>
  <ul class="custom-list">
    <li>{{ $t('digitalServices.move.benefitsCard.line1') }}</li>
    <li>{{ $t('digitalServices.move.benefitsCard.line3') }}</li>
    <li>{{ $t('digitalServices.move.benefitsCard.line4') }}</li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'benefits-card',
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
.benefits-card {
  background: $white;
  padding: 2.2rem 2rem 2.2rem 3rem;
  display: none;
  flex-direction: column;
  flex-basis: 100%;
  max-width: 100%;
  border-left: 1px solid $grey;

  @media (map_get($breakpoints, sm)) {
    display: flex;
    flex-basis: calc(50% - 1rem);
    max-width: calc(50% - 1rem);
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    color: $light-black;
  }

  ul.custom-list {
    list-style: none;
    padding: 4.8rem 1rem;

    @media (map_get($breakpoints, sm)) {
      min-height: 15rem;
      padding-bottom: 0;
    }

    li {
      color: $text-grey;
      margin-bottom: 1.6rem;
      padding-left: 2.6rem;
      line-height: 1.43;
      position: relative;
      font-size:1.4rem;

      &::before {
        position: absolute;
        top: 0;
        left: -.6rem;
        content: "\2022";
        font-family: Verdana, sans-serif;
        font-size: 1.4rem;
        color: $primary;
      }
    }
  }
}
</style>
